import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Layers } from "lucide-react";

import InquiryDialog from "./InquiryDialog";
import { PRODUCTS } from "../constants/testIds/site";

export default function ProductCard({ product, index = 0 }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        data-testid={PRODUCTS.card(product.slug)}
        className="group relative overflow-hidden rounded-xl border border-slate-200 bg-white transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(10,37,64,0.25)]"
      >
        <span className="corner-mark tl" />
        <span className="corner-mark tr" />

        <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
          <img
            src={product.images?.[0]}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.05]"
          />

          <div className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white/95 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider text-brand-navy backdrop-blur">
            <Layers className="h-3 w-3 text-accent" />
            {product.category_slug.replace(/-/g, " ")}
          </div>
        </div>

        <div className="p-5">
          <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-accent">
            Model {String(index + 1).padStart(2, "0")}
          </div>

          <h3 className="mt-1.5 line-clamp-1 font-display text-lg font-bold leading-tight tracking-tight text-brand-navy">
            {product.name}
          </h3>

          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-slate-500">
            {product.tagline}
          </p>

          <div className="mt-4 flex items-center gap-3">
            <Link
              to={`/products/${product.slug}`}
              data-testid={PRODUCTS.viewBtn(product.slug)}
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-navy transition-colors duration-200 hover:text-accent"
            >
              View Details
              <ArrowUpRight className="h-4 w-4" />
            </Link>

            <span className="text-slate-300">•</span>

            <button
              type="button"
              onClick={() => setOpen(true)}
              data-testid={PRODUCTS.inquireBtn(product.slug)}
              className="text-sm font-semibold text-slate-600 transition-colors duration-200 hover:text-brand-navy"
            >
              Enquire
            </button>
          </div>
        </div>
      </div>

      <InquiryDialog
        open={open}
        onOpenChange={setOpen}
        product={product}
      />
    </>
  );
}